import { FC } from 'react';

import { NavBar } from 'common/components';
import AppLayout from 'common/components/layouts/app-layout';
import CustomHeader from 'common/components/layouts/custom-header/custom-header';
import { translate } from 'common/config/i18n';
import { useAppSelector } from 'common/helpers/hooks';
import { getWalletTransferDetails } from 'common/store/wallet-transfer';

const WalletTransferLayout: FC = ({ children }) => {
  const transferInfo = useAppSelector(getWalletTransferDetails);

  return (
    <AppLayout CustomNavBar={WalletTransferNavBar}>
      <CustomHeader
        title="AstroPay OneTouch - Payment Link"
        description={translate('payment_link_complete', {
          amount: `${transferInfo.currency} ${transferInfo.amount}`,
          userName: transferInfo.sourceName,
        })}
      />
      {children}
    </AppLayout>
  );
};

const WalletTransferNavBar: FC = () => {
  return <NavBar />;
};

export default WalletTransferLayout;
